// extracted by mini-css-extract-plugin
module.exports = {"root":"EditListingDescriptionPanel_root__d1LNo","form":"EditListingDescriptionPanel_form__1crNy","title":"EditListingDescriptionPanel_title__26HgP"};